module.exports = __webpack_public_path__ + "media/images/application/podcast/gif-podcast-04dfabda650c4afbbcd15e53c5b1c5b9.gif";